import { match, select } from 'ts-pattern';
import { UploadElement } from './Element';
import { UploadType } from 'components/TemplateEditor/slateTypes';
import { useMemo } from 'react';
import { useUploadValue, UploadProvider } from './UploadContext';
import { UploadFile } from 'antd/es/upload/interface';
import { css } from '@emotion/css';
import { isURL } from 'utils/is';

interface SegmentRenderProps {
  segments?: Knowledge.SPU.Segment[];
}

interface MediaRenderProps {
  url: string;
  uploadType: UploadType;
}
const MediaRender = (props: MediaRenderProps) => {
  const { url, uploadType } = props;
  const file = useMemo<UploadFile | undefined>(() => {
    return isURL(url)
      ? {
          uid: url,
          name: url,
          thumbUrl: url,
          status: 'done',
        }
      : undefined;
  }, [url]);
  if (!file) return null;

  return <UploadElement file={file} uploadType={uploadType} />;
};

const SegmentRender = (props: SegmentRenderProps) => {
  const { segments } = props;
  const uploadValue = useUploadValue();
  if (!segments) return null;

  const nodes = segments.length
    ? segments.map((segment, index) => {
        return match(segment)
          .with({ type: 'TEXT', content: select('content') }, (i) => {
            return <div key={`text-${index}`}>{i.content}</div>;
          })
          .with({ type: 'IMAGE', content: select('content') }, (i) => {
            return (
              <div key={`image-${index}`} className="inline-block [&+.media]:ml-[6px]">
                <MediaRender url={i.content} uploadType="IMAGE" />
              </div>
            );
          })
          .with({ type: 'VIDEO', content: select('content') }, (i) => {
            return (
              <div key={`video-${index}`} className="inline-block [&+.media]:ml-[6px] ">
                <MediaRender url={i.content} uploadType="VIDEO" />
              </div>
            );
          })
          .otherwise(() => null);
      })
    : null;

  return (
    <div
      className={css`
        .ant-upload-list-picture-card-container {
          width: 60px;
          height: 60px;
          .ant-upload-list-item {
            padding: 4px;
          }
          .ant-upload-list-item-actions {
            button {
              display: none;
            }
          }
        }
      `}
    >
      <UploadProvider value={uploadValue}>{nodes}</UploadProvider>
    </div>
  );
};

export default SegmentRender;
